import React from "react";
// import { ISimpleData } from "../../../store/types/misc";
import { cva } from "class-variance-authority";
import { cn } from "../../../lib/utils";
import { twMerge } from "tailwind-merge";

export type TItem = { id: string; name: string; button_name?: string };

type TSimpleTab = {
  items: TItem[];
  focused: TItem;
  onClick: (data: TItem) => void;
  variant?: "default" | "small";
  className?: string;
  focusedClassName?: string;
  buttonAction?: (activeTab: TItem) => void;
};

const SimpleTab: React.FC<TSimpleTab> = ({
  items,
  focused,
  onClick,
  variant = "default",
  className,
  focusedClassName,
  buttonAction,
}) => {
  const tabVariant = cva(
    "flex flex-row items-center justify-center text-gray-700 capitalize rounded-lg bg-white transition-all duration-300 ease-in-out",
    {
      variants: {
        variant: {
          default: "bg-white p-1.5",
          small: "bg-gray-200/20 p-1",
        },
      },
      defaultVariants: {
        variant: "default",
      },
    }
  );

  return (
    <div
      className={cn(
        "flex items-center w-full",
        buttonAction ? "justify-between" : "justify-end"
      )}
    >
      {/* Tabs */}
      <div className={cn(tabVariant({ variant }))}>
        {items.map((item) => (
          <h3
            key={item.id}
            onClick={() => onClick(item)}
            className={twMerge(
              `cursor-pointer px-3 py-2 m-0 rounded-md transition-all ease-in-out duration-300 ${className} ${
                focused.id === item.id
                  ? `text-primary-600 bg-customgreen ${focusedClassName}`
                  : ""
              }`
            )}
          >
            {item.name}
          </h3>
        ))}
      </div>

      {/* Optional Button */}
      {buttonAction && focused.button_name && (
        <button
          onClick={() => buttonAction(focused)}
          className="ml-4 px-4 py-2 rounded-md bg-primary-600 text-white"
        >
          {focused.button_name}
        </button>
      )}
    </div>
  );
};

export default SimpleTab;
